"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
TripService.$inject = ['$http', 'api', 'Popeye', '$q'];
function TripService($http, api, Popeye, $q) {
    var service = {};
    var lastParams = {
        page: 1,
        count: 20
    };
    var harbours = null;
    var ships = null;
    service.fetch = function (p) {
        var params = {
            page: 1,
            count: 20
        };
        if (p && p.page) {
            params.page = p.page;
        }
        if (p && p.count) {
            params.count = p.count;
        }
        //retrieve last params
        if (!p && lastParams) {
            _.extend(params, lastParams);
        }
        //save last params
        lastParams = params;
        return api.get('/trips', params).then(function (items) {
            return items;
        });
    };
    service.getLastParams = function () {
        return lastParams;
    };
    service.fetchShips = function (params) {
        if (ships) {
            return $q.when(ships);
        }
        else {
            return api.get('/ships', params).then(function (response) {
                ships = response;
                return response;
            });
        }
    };
    service.fetchHarbours = function (params) {
        if (harbours) {
            return $q.when(harbours);
        }
        else {
            return api.get('/harbour', params).then(function (response) {
                harbours = response;
                return response;
            });
        }
    };
    service.save = function (item, diff) {
        if (item.id) {
            return api.update('/trips/' + item.id, diff);
        }
        else {
            return api.post('/trips', diff);
        }
    };
    service.saveRoute = function (data) {
        return api.post('/route/planned', data);
    };
    service.getPlannedRoute = function (id) {
        return api.get('/route/planned/' + id);
    };
    service.getOptimizedRoute = function (params) {
        return api.get('/route/optimized', params);
    };
    service.get = function (id) {
        return api.get('/trips/' + id);
    };
    service.unpackRoute = function (_route) {
        var route = _.omit(_route, ['route']);
        var i = 1;
        route.route = _.map(JSON.parse(atob(_route.route)), function (r) {
            return {
                wpt: i++,
                lon: r.longitude,
                lat: r.latitude,
                eta: moment_1.default.utc(r.time),
                distance: r.extensions.distance,
                bearing: r.extensions.bearing,
                speed: r.extensions.speed,
            };
        });
        return route;
    };
    service.packRoute = function (route) {
        var temp = [];
        _.each(route, function (val, idx) {
            temp.push({
                latitude: val.lat,
                longitude: val.lon,
                elevation: 0,
                time: val.eta.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                extensions: {
                    distance: val.distance,
                    bearing: val.bearing,
                    speed: val.speed,
                    fuel: 0,
                    v_component_of_wind: "-nan",
                    u_component_of_wind: "-nan",
                    v_component_Significant_height_of_combined_wind_waves_and_swell: "-nan",
                    u_component_Significant_height_of_combined_wind_waves_and_swell: "-nan",
                    Mean_period_of_wind_waveseight_of_combined_wind_waves_and_swell: "-nan"
                }
            });
        });
        return btoa(JSON.stringify(temp));
    };
    service.remove = function (id) {
        var delay = $q.defer();
        Popeye.openModal({
            templateUrl: "../scripts/apps/trips/views/remove-dialog.html",
            modalClass: 'remove',
            controller: ['$scope', 'notify', function ($scope, notify) {
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.confirm = function () {
                        return api.remove('/trips/' + id).then(function (response) {
                            $scope.ok(response);
                        });
                    };
                }]
        });
        return delay.promise;
    };
    service.locateShip = function (trip) {
        Popeye.openModal({
            templateUrl: "../scripts/apps/trips/views/locate-ship-dialog.html",
            modalClass: 'mapModal',
            controller: ['$scope', 'notify', function ($scope, notify) {
                    $scope.trip = trip;
                }]
        });
    };
    return service;
}
exports.TripService = TripService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/services/trip.ts
// module id = 565
// module chunks = 0